export const feedbackFr = {
  open: 'Donner un avis',
  title: 'Donner un avis',
  description:
    'Signalez un problème, une question ou une suggestion sans quitter la page actuelle.',
  submit: 'Envoyer le retour',
  submitting: 'Envoi …',
  types: {
    BUG: 'Quelque chose ne fonctionne pas',
    FEATURE_REQUEST: 'Demande de fonctionnalité',
    IMPROVEMENT: "Proposition d'amélioration",
    USABILITY: "Problème d'utilisation",
    DATA_ISSUE: 'Données incorrectes ou incomplètes',
    PERFORMANCE: 'Page lente ou bloquée',
    QUESTION: 'Question sur une fonction',
    OTHER: 'Autre',
  },
  urgencies: {
    LOW: 'Faible',
    NORMAL: 'Normale',
    HIGH: 'Élevée',
    BLOCKING: 'Je ne peux pas continuer',
  },
  reproducibility: {
    ALWAYS: 'Toujours',
    SOMETIMES: 'Parfois',
    ONCE: 'Une fois',
    NOT_TRIED: 'Pas encore essayé',
  },
  statuses: {
    SUBMITTED: 'Reçu',
    TRIAGED: 'Évalué',
    IN_PROGRESS: 'En cours',
    RESOLVED: 'Résolu',
    CLOSED: 'Fermé',
  },
  priorities: { LOW: 'Basse', MEDIUM: 'Moyenne', HIGH: 'Haute', CRITICAL: 'Critique' },
  fields: {
    type: 'Type de retour',
    urgency: 'Urgence ressentie',
    title: 'Titre court',
    description: 'Description détaillée',
    noSecrets:
      'Ne saisissez aucun mot de passe, jeton, donnée de paiement ou contenu confidentiel.',
    attemptedAction: 'Qu’avez-vous essayé ?',
    actualResult: 'Que s’est-il réellement passé ?',
    expectedResult: 'Qu’attendiez-vous ?',
    reproducibility: 'Le problème est-il reproductible ?',
    reproductionSteps: 'Étapes de reproduction facultatives',
    affectedFeature: 'Fonction concernée (facultatif)',
    wantsFollowUp: 'Je souhaite être recontacté',
    problematicFields: 'Champs problématiques',
    choose: 'Veuillez choisir',
  },
  bug: { title: 'Détails du bogue' },
  screenshot: {
    title: 'Capture d’écran (facultatif)',
    hint: 'Vérifiez et masquez les zones confidentielles avant l’envoi.',
    choose: 'Choisir une image',
    remove: 'Supprimer',
    invalid: 'Impossible de lire l’image.',
    maskArea: 'Zone de masquage',
    maskInstructions:
      'Faites glisser sur les zones confidentielles pour les noircir définitivement.',
    resetMasks: 'Réinitialiser les masques',
  },
  diagnostics: {
    includeExtended: 'Joindre les diagnostics avancés',
    title: 'Afficher les diagnostics',
    transparency:
      'Vous choisissez les sections techniques transmises. Le contexte de session vérifié est ajouté par le serveur.',
    exclusions:
      'Les saisies, recherches, mots de passe, jetons, messages, fichiers, presse-papiers, audio, caméra, position et mouvements de souris ne sont jamais collectés.',
    sections: {
      APPLICATION: 'Application et build',
      PAGE: 'Page actuelle',
      BROWSER: 'Navigateur et appareil',
      BREADCRUMBS: 'Actions sémantiques récentes',
    },
  },
  discard: {
    title: 'Supprimer le brouillon ?',
    description: 'Les informations non envoyées seront perdues.',
    continue: 'Continuer',
    confirm: 'Supprimer le brouillon',
  },
  success: {
    title: 'Retour envoyé',
    description: 'Conservez cette référence pour toute question.',
    toast: 'Le retour {{reference}} a été envoyé.',
  },
  admin: {
    requested: 'Oui',
    nav: 'Centre de retours',
    title: 'Centre de retours',
    subtitle: 'Gérer les retours volontaires avec un contexte de diagnostic nettoyé.',
    loadError: 'Impossible de charger les retours.',
    empty: 'Aucun retour ne correspond aux filtres.',
    detailTitle: 'Détails du retour',
    screenshotAlt: 'Capture masquée pour {{reference}}',
    triage: 'Évaluation technique',
    unrated: 'Non évalué',
    saved: 'Retour mis à jour.',
    invalidErrorIds: 'Les références d’erreur ne sont pas valides.',
    linkedErrors: 'Erreurs système liées',
    kpi: { open: 'Retours ouverts', untriaged: 'Non évalués', last24h: 'Dernières 24 heures' },
    columns: {
      reference: 'Référence',
      createdAt: 'Date',
      type: 'Type',
      title: 'Titre',
      user: 'Utilisateur',
      status: 'Statut',
    },
    fields: {
      status: 'Statut de traitement',
      priority: 'Priorité technique',
      errorIds: 'Identifiants d’erreur (séparés par des virgules)',
      notes: 'Notes internes',
    },
    filters: {
      search: 'Référence, titre ou description',
      type: 'Filtrer le type',
      status: 'Filtrer le statut',
      priority: 'Filtrer la priorité',
      all: 'Tous',
    },
    prompt: {
      title: 'Prompt support/Copilot nettoyé',
      hint: 'Les textes et diagnostics sont vérifiés à nouveau avant la copie.',
      copy: 'Copier le prompt nettoyé',
      copied: 'Prompt nettoyé copié.',
    },
  },
} as const;
